import { apiGatewayClient } from "./client"

export const ApiGatewayMutations = {
  cancellationReason: {
    submit: () => ({
      mutationFn: (payload: object) =>
        apiGatewayClient.post("/customers/cancellation-reason", { ...payload }),
    }),
    update: () => ({
      mutationFn: (payload: object) =>
        apiGatewayClient.put("/customers/cancellation-reason", { ...payload }),
    }),
  },
  bill: {
    issue: (juniferId: number) => ({
      mutationFn: () =>
        apiGatewayClient.post(`/accounts/${juniferId}/hot_bill`),
    }),
  },
  imbp: {
    submit: () => ({
      mutationFn: (payload: object) =>
        apiGatewayClient.post(`smart-meter/book-reservation`, {
          ...payload,
        }),
    }),
    cancelBookings: (billingAccountId: number, bookingId: string) => ({
      mutationFn: (payload: {
        reason: string
        initiatedBy: string
        mop?: string
      }) =>
        apiGatewayClient.post(
          `smart-meter/${billingAccountId}/cancel-booking`,
          {
            jobNumber: bookingId,
            cancellationSource: "NOVA",
            ...payload,
          },
        ),
    }),
    reserveSlot: () => ({
      mutationFn: (payload: object) =>
        apiGatewayClient.post(`smart-meter/reserve-slot`, {
          ...payload,
        }),
    }),
  },
  consent: {
    update: () => ({
      mutationFn: (payload: object) =>
        apiGatewayClient.put(
          "/smart-meter/meter-point/meter-reading-frequency",
          payload,
        ),
    }),
  },
}
